import Text from 'components/core/Text';
import imageUrlGenerator from '../../../../../../utils/imageUrlGenerator';

import { Wrapper, Session, SessionAvatar, SessionDescription, SessionAbout } from './styles';

export default function SessionBreakdown({ program }) {
  const getSessionId = () => {
    const { sessions = [], lastSession, nextSession } = program;
    const { id: latestSessionId } = lastSession || {};
    const latestSessionCompleted = lastSession?.workout?.completedAt;

    if (!latestSessionCompleted && !latestSessionId) {
      return nextSession?.id || sessions[0].id;
    }

    if (latestSessionId && !nextSession?.id) {
      return latestSessionId;
    }

    return nextSession?.id || null;
  };

  const getSessionDetails = () => {
    const sessionId = getSessionId();
    const trackSession =
      program.programTrack.programTrackSessions.find(
        (item) => item.id === program.nextTrackSessionId,
      ) || program.programTrack.programTrackSessions.find((item) => item.session.id === sessionId);

    return program.sessions?.length
      ? {
          ...program.sessions.find((session) => session.id === sessionId),
          ...trackSession,
        }
      : null;
  };

  const allTrackSessions = program.programTrack.programTrackSessions
    ?.filter((item) => !item.session.isBasic && item.session.challengeOrder == null)
    ?.sort((a, b) => a.order - b.order);

  if (!program.sessions?.length) return null;

  const currentSessionDetails = getSessionDetails();

  // Filter to show only current session and next 5 upcoming sessions.
  // Don't show sessions prior to the current session.
  const trackSessions =
    allTrackSessions?.filter((track) => track.order >= currentSessionDetails.order)?.slice(0, 5) ||
    [];

  // For looping programs nearing the end, append sessions from the loop
  // target onward so the upcoming list reflects the wrap-around cycle rather
  // than running empty.
  const loopBackId = program.programTrack?.loopBackToTrackSessionId;
  if (loopBackId != null && trackSessions.length < 5 && allTrackSessions?.length) {
    const loopBackIndex = allTrackSessions.findIndex((t) => t.id === loopBackId);
    if (loopBackIndex >= 0) {
      const seen = new Set(trackSessions.map((t) => t.id));
      for (let i = loopBackIndex; i < allTrackSessions.length && trackSessions.length < 5; i += 1) {
        const pts = allTrackSessions[i];
        if (!seen.has(pts.id)) {
          trackSessions.push(pts);
          seen.add(pts.id);
        }
      }
    }
  }

  return (
    <Wrapper>
      {trackSessions?.map((track) => {
        // Extract description and strip HTML tags
        const sessionDescription = track.session.description?.replace(/<[^>]*>/g, '') || '';

        return (
          <Session
            key={track.id}
            href={`/programs/${program.id}/sessions/${track.session.id}?trackSessionId=${track.id}`}
          >
            <SessionAvatar
              style={{
                backgroundImage: `url(${imageUrlGenerator(
                  track.session.picture,
                  '60x60',
                  '60x60',
                )})`,
              }}
            />
            <SessionDescription>
              <SessionAbout>
                <Text variant="textSmall" tag="h3" weight="bold" color="black">
                  {track.session.name}
                </Text>
                <Text variant="captionSmall" color="grayLight" mb={1}>
                  {sessionDescription && sessionDescription.length > 50
                    ? `${sessionDescription.slice(0, 50)}...`
                    : sessionDescription}
                </Text>
              </SessionAbout>
            </SessionDescription>
          </Session>
        );
      })}
    </Wrapper>
  );
}
